import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  Typography,
  List,
  Space,
  Radio,
  Tag,
  message,
} from "antd";
import {
  CalendarOutlined,
  EditOutlined,
  DeleteOutlined,
  BellOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import FloatLabel from "../FloatLabel";
import DetailsList from "../DetailsList";
import moment from "moment";
import DateModalTask from "../CalenderModal/DateModalTask";
import TimeSelect from "../CalenderModal/TimeSelect";
import Reminder from "../CalenderModal/Reminder";
import RepeatModal from "../CalenderModal/RepeatModal";
import { RepeatOnOutlined } from "@mui/icons-material";
import { URL } from "../../helper/Mainurl";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
const { Text, Paragraph } = Typography;
const ViewEmail = ({ visible, onCancel, onSave, metaCalender, email }) => {
  const [form] = Form.useForm();
  //  const [editView, setEditView] = useState(false);
  const [taskData, setTaskData] = useState({
    title: "",
    description: "",
    location: "",
  });
  console.log(email, "email in view email");

  const [progressStatus, setProgressStatus] = useState([]);
  const [getProgressStatus, setGetProgressStatus] = useState([]);

  const [error, setError] = useState(false);
  const [priority, setPriority] = useState([]);
  const [displayName, setDisplayName] = useState([]);
  const [editView, setEditView] = useState(false);
  const [selectedDisplayId, setSelectedDisplayId] = useState(null);
  const [selectedPriorityIds, setSelectedPriorityIds] = useState([]);
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [repeatConfig, setRepeatConfig] = useState(null);
  const [switchStatesRepeat, setSwitchStatesRepeat] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [repeatOption, setRepeatOption] = useState([]);
  const [adjusWeekend, setAdjustWeekend] = useState([]);

  const [checklist, setChecklist] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [showRemModal, setShowRemModal] = useState(false);
  const [descSelectedReminder, setDescSelectedReminder] =
    useState("No reminder");
  const [switchStates, setSwitchStates] = useState(false);
  const [eventType, setEventType] = useState("");
  const [switchTimeStates, setSwitchTimeStates] = useState(false);
  const [switchStatesRem, setSwitchStatesRem] = useState(false);

  const [selectedTime, setSelectedTime] = useState({
    start: null,
    end: null,
  });

  const [deletedChecklistIds, setDeletedChecklistIds] = useState([]);
  const [selectReminder, setSelectReminder] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState("No reminder");
  const [inputText, setInputText] = useState("");
  const [inputTextDesc, setInputTextDesc] = useState(null);

  const [locationText, setLocationText] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [emailId, setEmailId] = useState(null);

  const [emailTitle, setEmailTitle] = useState(null);
  const [emailDesc, setEmailDesc] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");

  const [formattedTime, setFormattedTime] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const token = localStorage.getItem("authToken"); // Get token from localStorage
  const getReminderPresetLabel = (startTime, reminderTime) => {
    if (!startTime || !reminderTime) return "No reminder";
    const diffMinutes = moment(startTime).diff(moment(reminderTime), "minutes");
    if (diffMinutes === 5) return "5 minute before";
    if (diffMinutes === 30) return "30 minute before";
    if (diffMinutes === 60) return "1 hour before";
    if (diffMinutes === 1440) return "1 day before";
    if (diffMinutes > 0) return "Customize...";
    return "No reminder";
  };
  useEffect(() => {
    console.log("email", email);
    if (email) {
      form.setFieldsValue({
        title: email.subject,
        description: email.description || "",
        location: email.location || "",
        // priority_id: email.priority_id || null
      });
      setLocationText(email.location);
      setEmailTitle(email.title);
      setEmailDesc(email.description);
      // setGetProgressStatus(email.progress_status_id);
      const eventDate = moment(email.start_date);
      const today = moment();
      const tomorrow = moment().add(1, "day");

      let prefix = "";
      if (eventDate.isSame(today, "day")) {
        prefix = "Today, ";
      } else if (eventDate.isSame(tomorrow, "day")) {
        prefix = "Tomorrow, ";
      }
      if (email?.start_time && email?.end_time) {
        const start = moment.utc(email.start_time).format("HH:mm");
        const end = moment.utc(email.end_time).format("HH:mm");
        setFormattedTime(`${start} - ${end}`);
        setSelectedTime({
          start: start,
          end: end,
        });
        setSwitchTimeStates(true);
        console.log("setSelectedTime", selectedTime);
      }

      setFormattedDate(`${prefix}${eventDate.format("DD MMMM YYYY")}`);
      setSelectedDate(eventDate.format("DD MMMM YYYY"));
      setSwitchStates(true);
      // const selectedProgressStatus = progressStatus.find(status => status.id == email.progress_status_id) || { id: "", label_name: "Unknown" };

      setEditView(false);
    }
  }, [email, form]);

  useEffect(() => {
    if (!email) return; // Prevent errors if email is null/undefined
    setEmailId(email.id);
    // Set selected priority ID
    setSelectedPriorityIds(
      email.priority_id ? Number(email.priority_id) : null
    );

    // Find and set selected progress status
    if (email.progress_status_id && Array.isArray(progressStatus)) {
      const selectedProgressStatus =
        progressStatus.find(
          (status) => status.id == email.progress_status_id
        ) || null;

      console.log("Selected Progress Status:", selectedProgressStatus);
      setGetProgressStatus(selectedProgressStatus); // Ensure this updates an object
      setSelectedRadio(selectedProgressStatus?.id || null);
    }

    // Find and set selected priority (Store it separately)
    if (email.priority_id && Array.isArray(priority)) {
      const foundPriority =
        priority.find((status) => status.id == email.priority_id) || null;
      console.log("Selected Priority:", foundPriority);
      setSelectedPriority(foundPriority); // Store full object
    }
  }, [email, progressStatus, priority]);
  // email itself should be in dependencies

  const handleDateSelect = (date) => {
    console.log("Selected date:", date);
    setFormattedDate(date);
    setSwitchStates(!!date); // Make sure `setSelectedDate` is defined using `useState`
    setSelectedDate(date);
  };
  useEffect(() => {
    console.log("Updated progressStatus:", progressStatus);
  }, [progressStatus]);
  useEffect(() => {
    if (email) {
      // --- Repeat ---
      if (email.repeat_option) {
        setRepeatConfig({
          repeatType: {
            value: email.repeat_option,
            label_name:
              email.repeat_option.charAt(0).toUpperCase() +
              email.repeat_option.slice(1),
          },
          endType: email.repetition_end_date ? "custom" : "after",
          occurrences: 2, // You can calculate based on dates if needed
          customEndDate: email.repetition_end_date
            ? moment(email.repetition_end_date).format("YYYY-MM-DD")
            : null,
          excludeWeekends: [
            ...(Number(email.exclude_saturdays)
              ? [{ id: 2, label: "saturday" }]
              : []),
            ...(Number(email.exclude_sundays)
              ? [{ id: 3, label: "sunday" }]
              : []),
          ],
          adjustWeekends: email.adjust_weekends || false,
        });
        setSwitchStatesRepeat(true);
      } else {
        setRepeatConfig(null);
        setSwitchStatesRepeat(false);
      }

      // --- Reminder ---
      if (email.reminder_timestamp) {
        // Calculate diff in minutes between start and reminder
        let reminderText = email.reminder_timestamp
          ? getReminderPresetLabel(email.start_time, email.reminder_timestamp)
          : "No reminder";
        console.log("Reminder Text:", reminderText);
        setDescSelectedReminder(reminderText);
        setSwitchStatesRem(true); // ✅ Enable switch if reminder exists
      } else {
        setDescSelectedReminder("No reminder");
        setSwitchStatesRem(false);
      }
    }
  }, [editView, email]);

  const handleSelectTime = (time) => {
    console.log("SelectedTime:", time);

    const formattedStartTime = moment(time.start, "HH:mm");
    const formattedEndTime = moment(time.end, "HH:mm");

    const formattedTime = {
      start: formattedStartTime.format("HH:mm"),
      end: formattedEndTime.format("HH:mm"),
    };

    console.log("Formatted Time:", formattedTime);

    setSelectedTime(formattedTime);
    setSwitchTimeStates(!!time);
    console.log("SelectedTime:>>>>>", selectedTime);
    //  const { taskStartTime, reminderText } = formatDateTimeRem(selectedDate, selectedTime, selectedReminder);

    //  setDescSelectedReminder(reminderText);
  };

  const selectTextReminder = (item) => {
    console.log("nananan", item);
    setDescSelectedReminder(item);
  };
  const handleSelectReminder = (reminder) => {
    const { taskStartTime, reminderText } = formatDateTimeRem(
      selectedDate,
      selectedTime,
      reminder
    );
    setSelectedReminder(reminder);
    setDescSelectedReminder(reminderText);
    setSwitchStatesRem(!!reminder);

    console.log("SelectedReminder>>", reminder);
  };
  const handleRepeatCancel = () => {
    if (!repeatConfig) setSwitchStatesRepeat(false);
    setShowRepeatModal(false);
  };
  const handleRepeatSave = (data) => {
    setRepeatConfig(data);
    setSwitchStatesRepeat(true);
    setShowRepeatModal(false);
  };
  const formatDateTimeRem = (selectedDate, selectedTime, selectedReminder) => {
    const validReminderMap = {
      5: "5 minute before",
      30: "30 minute before",
      60: "1 hour before",
      1440: "1 day before",
    };

    const formattedDate = moment(selectedDate, [
      "D MMMM YYYY",
      "DD, MMMM YYYY",
      "YYYY-MM-DD",
      "MM/DD/YYYY",
      "DD MMM YYYY",
    ]);

    if (!formattedDate.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid date" };
    }

    const formattedStartTime = moment(selectedTime?.start, [
      "HH:mm",
      "HH:mm:ss",
    ]);
    if (!formattedStartTime.isValid()) {
      return { taskStartTime: null, reminderText: "Invalid time" };
    }

    const taskStart = moment.utc(
      `${formattedDate.format("YYYY-MM-DD")}T${formattedStartTime.format(
        "HH:mm"
      )}:00Z`
    );

    const taskStartTime = taskStart.format("YYYY-MM-DDTHH:mm:ss[Z]");
    const reminderTime = moment.utc(selectedReminder);

    if (!reminderTime.isBefore(taskStart)) {
      return { taskStartTime, reminderText: "No reminder" };
    }

    const diffMinutes = taskStart.diff(reminderTime, "minutes");

    if (validReminderMap[diffMinutes]) {
      return { taskStartTime, reminderText: validReminderMap[diffMinutes] };
    }

    // Compute human-readable fallback for Customize...
    const totalMinutes = diffMinutes;
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);

    const customizeLabel =
      parts.length > 0
        ? `Customize...(${parts.join(", ")} before)`
        : "Customize...";

    return { taskStartTime, reminderText: customizeLabel };
  };
  const handleDelete = async (id) => {
    console.log("Delete checklist item with ID:", [id]);
    try {
      const response = await fetch(`${URL}/v1/parsed-email/delete`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: [id], // Convert IDs to numbers
        }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Failed to delete: ${errorData.message || response.statusText}`
        );
      }
      message.success("Emails deleted successfully!");
      window.location.reload(); // Reload the page to reflect changes
    } catch (error) {
      console.error("Error deleting checklist item:", error);
    } // Track deleted IDs
  };

  const handleEditOpen = () => {
    setTaskData({
      //   title: eventData.title || "",
      //   description: eventData.description || "",
      //   location: eventData.location || "",
      //   checklists: eventData.checklists || "",
      //   progressStatusId:eventData.progressStatusId || "",
      //   displaynameId:eventData.displaynameId || ""
    });

    //   setInputText(eventData.title);
    //    setInputTextDesc(eventData.description);
    //   setLocationText(eventData.location);
    //   setSelectedDate(formattedDate);
    //   if(formattedDate){
    //          setSwitchStates(true);
    //   }

    //   setSelectedTime({formattedstartTime} - {formattedendTime});
    //   console.log("formattedstartTime::::::",formattedstartTime,formattedendTime,selectedTime)
    //   setSelectedReminder(result);

    setEditView(true);
    setEditEmail(true);
  };
  const handleCalenderOpen = () => {
    setTaskData({
      //   title: eventData.title || "",
      //   description: eventData.description || "",
      //   location: eventData.location || "",
      //   checklists: eventData.checklists || "",
      //   progressStatusId:eventData.progressStatusId || "",
      //   displaynameId:eventData.displaynameId || ""
    });

    setEditView(true);
    setEditEmail(false);
  };
  const handleviewOpen = () => {
    setEditView(false);
    setEditEmail(false);
    setEditView(false);
  };
  const handleChange = (e) => {
    console.log("newdata", e);
    setEmailTitle(e.target.value);
    setError(false); // Clear error when user types

    // Update state on input change
  };
  const handleChangeDesc = (e) => {
    setEmailDesc(e.target.value); // Update state on input change
  };
  const handleChangeLocation = (e) => {
    setLocationText(e.target.value); // Update state on input change
  };

  const handleRadioChange = (e) => {
    const newStatusId = e.target.value;
    setSelectedRadio(newStatusId);

    // Find the selected status object
    const selectedStatus =
      progressStatus.find((status) => status.id == newStatusId) || null;
    setGetProgressStatus(selectedStatus); // Update the progress status object

    console.log("Updated Selected Progress Status:", selectedStatus);
  };
  const handleSwitchChange = () => {
    setShowModal(true);
  };
  const handleSwitchChangeTime = () => {
    setShowTimeModal(true);
  };
  const handleSwitchChangeRem = () => {
    console.log("handleSwitchChangeRem::", switchStatesRem);
    const newState = !switchStatesRem;
    setSwitchStatesRem(newState);
    if (!newState) {
      // If the switch was ON and now turned OFF, show the modal
      // setShowRemModal(true);
      setSwitchStatesRem(false);
      setDescSelectedReminder("No reminder");
    } else {
      // If the switch was OFF and now turned ON
      setSelectedReminder(null);
      setSwitchStatesRem(true); // Ensure the switch turns ON
      setShowRemModal(true);
    }
  };

  const handleUpdateApply = async () => {
    setSubmitLoading(true);
    if (!emailTitle.trim()) {
      setError(true);
      message.error("Task name is required!");
      setSubmitLoading(false);
      return;
    }

    const formattedStartDate = moment(selectedDate, "D MMMM YYYY").format(
      "YYYY-MM-DD"
    );

    let todaysDate = moment().startOf("day");
    if (formattedStartDate && moment(formattedStartDate).isBefore(todaysDate)) {
      message.error("Start date cannot be in the past.");
      setSubmitLoading(false);
      return;
    }
    let formattedDate = moment(
      formattedStartDate,
      ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );
    const getRepetitionEndDate = () => {
      if (!repeatConfig || !formattedStartDate) return null;

      const { endType, occurrences, customEndDate } = repeatConfig;

      if (endType === "custom" && customEndDate) {
        return moment(customEndDate).format("YYYY-MM-DD");
      }

      return moment(formattedStartDate)
        .add(occurrences, "years")
        .format("YYYY-MM-DD");
    };

    if (!formattedDate.isValid()) {
      formattedDate = moment(
        selectedDate,
        ["YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY", "MM/DD/YYYY"],
        true
      );
    }

    let formattedStartTime = selectedTime?.start
      ? moment(selectedTime.start, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "00:00";

    const currentTime = moment().format("HH:mm");

    if (
      formattedStartTime < currentTime &&
      formattedDate.isSame(todaysDate, "day")
    ) {
      message.error("Start time cannot be in the past for today's date.");
      setSubmitLoading(false);
      return;
    }

    let formattedEndTime = selectedTime?.end
      ? moment(selectedTime.end, ["HH:mm", "HH:mm:ss"], true).format("HH:mm")
      : "23:59";

    const taskStartTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedStartTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");

    const taskEndTime = moment
      .utc(`${formattedDate.format("YYYY-MM-DD")} ${formattedEndTime}`)
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    let formattedReminder = selectedReminder
      ? moment(selectedReminder, "YYYY-MM-DD HH:mm").format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        )
      : null;
    if (email.reminder_timestamp) {
      formattedReminder = moment(
        email.reminder_timestamp,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DDTHH:mm:ss[Z]");
    }
    const checkListItems =
      checklist?.map(
        ({ checklist_id, title, description = null, checked, new_status }) => ({
          checklist_id: new_status ? null : checklist_id,
          title,
          description,
          is_checked: checked ? 1 : 0,
        })
      ) || [];

    const hasSaturday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "saturday"
    );
    const hasSunday = repeatConfig?.excludeWeekends?.some(
      (w) => w.label === "sunday"
    );
    let adjustWeekendsValue = null;

    if (repeatConfig?.adjustWeekends) {
      if (hasSaturday && hasSunday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSaturday) {
        adjustWeekendsValue = "previous_friday";
      } else if (hasSunday) {
        adjustWeekendsValue = "previous_saturday";
      }
    }
    // **Prepare Payload**
    const payload = {
      title: emailTitle,
      location: locationText,
      description: emailDesc,
      display_name_id: 20,
      priority_id: selectedPriority.id,
      progress_status_id: getProgressStatus.id,
      start_date: formattedStartDate,
      start_time: taskStartTime,
      end_time: taskEndTime,
      ...(!editEmail && { parsed_event_id: emailId }),
      repeat_option: repeatConfig?.repeatType?.value || null,
      repetition_end_date: getRepetitionEndDate(),
      reminder_timestamp: switchStatesRem ? formattedReminder : null,
      exclude_saturdays: hasSaturday ? 1 : 0,
      exclude_sundays: hasSunday ? 1 : 0,
      adjust_weekends: adjustWeekendsValue,
    };

    console.log("payload", payload);

    try {
      // **Decide API URL based on `EditEmail`**
      let apiUrl = editEmail
        ? `${URL}/v1/parsed-email/update/${emailId}` // Email API
        : `${URL}/v1/event/create`; // Calendar API

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok) {
        message.success(
          editEmail
            ? "Email updated successfully!"
            : "Calendar updated successfully!"
        );
        setEditEmail(false); // Reset after update
        onCancel(false);
        setSubmitLoading(false);
      } else {
        setSubmitLoading(false);
        throw new Error(result.message || "Failed to update");
      }
    } catch (error) {
      setSubmitLoading(false);
      console.error("Error updating:", error);
      message.error(error?.message);
    }
  };

  const handleSelectPriority = (id) => {
    const selected = priority.find((status) => status.id == id) || null;
    setSelectedPriority(selected);
  };
  useEffect(() => {
    getCalenderMetaData();
  }, []);
  const getCalenderMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/calendar/get-calendar-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      console.log("response>>>>>", data);

      if (data.code == 200) {
        setProgressStatus(data.data.progress_status);
        setDisplayName(data.data.display_name);
        setPriority(data.data.priority);
        setRepeatOption(data.data.repeat_option);
        console.log("progressStatus", progressStatus);
        metaCalender(data.data);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      console.log("response>>>>>", data);
    } catch (error) {}
  };
  const onModalCancel = () => {
    onCancel(false);
    setEditView(false);
  };
  return (
    <div>
      <Modal
        title=""
        open={visible}
        onCancel={() => onModalCancel(false)}
        footer={null}
      >
        {!editView ? (
          <div style={{ marginTop: "25px" }}>
            {/* Header Section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "10px 0px",
              }}
            >
              <h3 level={4} style={{ textTransform: "capitalize" }}>
                <strong>Summary</strong>
              </h3>
              <div>
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  style={{ marginRight: 8 }}
                  onClick={handleEditOpen}
                >
                  Edit
                </Button>
                <Button
                  type="text"
                  onClick={() => setShowDeleteModal(true)}
                  icon={<DeleteOutlined style={{ color: "#9A4FE0" }} />}
                  className="add-task-checklist-btn"
                />
              </div>
            </div>

            {/* Task Name & Description */}
            <h3 level={5}>{emailTitle}</h3>

            <div>
              <Text>{emailDesc}</Text>
            </div>

            <div>
              <Paragraph style={{ marginTop: "10px" }}>
                <strong>Location: </strong>
                {locationText}
              </Paragraph>
            </div>

            {/* Status & Priority */}
            {getProgressStatus && (
              <div style={{ marginTop: 16 }}>
                <h3 level={5}>Status</h3>
                <Tag className="ant-tag-btn">
                  {getProgressStatus.label_name}
                </Tag>
              </div>
            )}
            {selectedPriority && (
              <div style={{ marginTop: 16 }}>
                <h3 level={5}>Priority</h3>
                <Tag className="ant-tag-btn">{selectedPriority.label_name}</Tag>
              </div>
            )}

            {/* Task Details */}
            <div style={{ marginTop: "30px" }}>
              <h3 style={{fontWeight: 'bold'}} level={5}>Detail</h3>
              <List>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CalendarOutlined
                      style={{ marginRight: 8, fontSize: 16 }}
                    />
                    <Text strong>Date</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {formattedDate}
                  </Text>
                </List.Item>

                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <ClockCircleOutlined
                      style={{ marginRight: 8, fontSize: 16 }}
                    />
                    <Text strong>Time</Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {formattedTime}
                  </Text>
                </List.Item>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <BellOutlined style={{ marginRight: 8, fontSize: 16 }} />
                    <Text strong>
                      {" "}
                      <Text strong>Reminder</Text>
                    </Text>
                  </div>
                  <Text style={{ marginLeft: 26, color: "#555" }}>
                    {descSelectedReminder}
                  </Text>
                </List.Item>
                <List.Item
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <RepeatOnOutlined
                      style={{
                        marginRight: 8,
                        fontSize: "22px",
                        color: "#666",
                      }}
                    />
                    <Text strong>Repeat</Text>
                  </div>
                  <Text style={{ marginLeft: 28 }}>
                    {email?.repeat_option
                      ? `${email.repeat_option
                          .charAt(0)
                          .toUpperCase()}${email.repeat_option.slice(1)}`
                      : "No Repeat"}{" "}
                    {email?.repetition_end_date &&
                      `(End until ${moment(email.repetition_end_date).format(
                        "D, MMMM YYYY"
                      )})`}
                  </Text>
                </List.Item>
              </List>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                gap: "5px",
              }}
            >
              <Button
                className="modal-cancel-btn"
                onClick={() => onCancel(false)}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="modal-success-btn"
                onClick={handleCalenderOpen}
              >
                Add To Calender
              </Button>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: "25px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "10px 0px",
              }}
            >
              <h3 level={4} style={{ textTransform: "capitalize" }}>
                <EditOutlined /> Edit{" "}
              </h3>
              <div>
                <Button className="reset-btn" onClick={handleviewOpen}>
                  Cancel
                </Button>
              </div>
            </div>
            <div className="addTaskLabel">
              <FloatLabel
                label="What is the name of your task"
                name="taskTitle"
                value={emailTitle}
              >
                <Input value={emailTitle} onChange={handleChange} />
              </FloatLabel>
              {/* {error && <Text type="danger">{tabName} Name is required!</Text>} */}
            </div>

            <FloatLabel
              label="Description"
              name="taskDescription"
              value={emailDesc}
            >
              <Input.TextArea
                value={emailDesc}
                onChange={handleChangeDesc}
                autoSize={{ minRows: 1, maxRows: 6 }}
              />
            </FloatLabel>

            <FloatLabel
              label="Location"
              name="taskLocation"
              value={locationText}
            >
              <Input value={locationText} onChange={handleChangeLocation} />
            </FloatLabel>
            {Array.isArray(progressStatus) && progressStatus.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <div className="radio-container">
                  {/* <p className="radio-label">Status</p> */}
                  <h3>Status</h3>
                  <Radio.Group
                    className="custom-radio-group"
                    onChange={handleRadioChange}
                    value={getProgressStatus.id}
                  >
                    {progressStatus.map((status) => {
                      return (
                        <Radio
                          key={status.id}
                          value={status.id}
                          className="custom-radio"
                        >
                          {status.label_name}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </div>
              </div>
            )}
            <div>
              <h3>Priority</h3>
              <div className="email-priority-tags">
                {Array.isArray(priority) && priority.length > 0 ? (
                  priority.map((status) => (
                    <Tag
                      key={status.id}
                      onClick={() => handleSelectPriority(status.id)}
                      style={{
                        backgroundColor:
                          selectedPriority?.id === status.id
                            ? "#FEF1FE"
                            : "#ffffff",
                        color:
                          selectedPriority?.id === status.id
                            ? "#9A4FE0"
                            : "#000",
                        border:
                          selectedPriority?.id === status.id
                            ? "1px solid #9A4FE0"
                            : "1px solid #E1E6EF",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "8px 12px",
                        lineHeight: "18px",
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      {status?.label_name || "Unknown"}
                    </Tag>
                  ))
                ) : (
                  <p style={{ color: "#999" }}>Loading...</p>
                )}
              </div>
            </div>
            <div>
              <div className="details-container">
                <h3 className="details-title details-title-email">Detail</h3>
                <DetailsList
                  icon={<CalendarOutlined />}
                  title="Date"
                  description={formattedDate || "No date selected"}
                  switchChecked={switchStates}
                  onSwitchChange={() => handleSwitchChange()}
                  onClick={() => setShowModal(true)} // Open modal on click
                />
                <DetailsList
                  icon={<ClockCircleOutlined />}
                  title="Time"
                  description={
                    selectedTime.start && selectedTime.end
                      ? `${selectedTime.start} - ${selectedTime.end}`
                      : "Not Set"
                  }
                  switchChecked={switchTimeStates}
                  onSwitchChange={() => handleSwitchChangeTime()}
                  onClick={() => setShowTimeModal(true)}
                />

                <DetailsList
                  icon={<BellOutlined />}
                  title="Reminder"
                  description={descSelectedReminder}
                  switchChecked={switchStatesRem}
                  onSwitchChange={handleSwitchChangeRem}
                  onClick={() => setShowRemModal(true)}
                />
                <DetailsList
                  icon={<RepeatOnOutlined />}
                  title="Repeat"
                  description={
                    !switchStatesRepeat || !repeatConfig
                      ? "No repeat"
                      : repeatConfig?.repeatType?.label_name || "Custom"
                  }
                  switchChecked={switchStatesRepeat}
                  onSwitchChange={() => {
                    const newState = !switchStatesRepeat;
                    setSwitchStatesRepeat(newState);
                    if (newState) setShowRepeatModal(true);
                    else setRepeatConfig(null);
                  }}
                  onClick={() => setShowRepeatModal(true)}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
                gap: "5px",
              }}
            >
              <Button className="modal-cancel-btn" onClick={handleviewOpen}>
                Cancel
              </Button>
              <Button
                type="primary"
                className="modal-success-btn"
                loading={submitLoading}
                disabled={submitLoading}
                onClick={handleUpdateApply}
              >
                Apply
              </Button>
            </div>
          </div>
        )}
      </Modal>
      <div>
        {/* <DateCalender isOpen={isCalendarOpen} onClose={() => setIsCalendarOpen(false)} onSelectDate={handleSelectDate} /> */}
        <DateModalTask
          show={showModal}
          handleClose={() => setShowModal(false)}
          onDateSelect={handleDateSelect}
          selectedDate={selectedDate}
        />
      </div>

      <div>
        <TimeSelect
          show={showTimeModal}
          handleClose={() => setShowTimeModal(false)}
          onSelectTime={handleSelectTime}
          selectedTime={selectedTime}
          selectedDate={selectedDate}
        />
      </div>
      <div>
        <Reminder
          show={showRemModal}
          handleClose={() => setShowRemModal(false)}
          onSelectReminder={handleSelectReminder}
          eventDate={selectedDate}
          eventTime={selectedTime}
          selectReminderTime={selectTextReminder}
          initialReminder={descSelectedReminder}
          eventData={email}
        />
      </div>
      {showRepeatModal && (
        <RepeatModal
          visible={showRepeatModal}
          onCancel={handleRepeatCancel}
          onSave={handleRepeatSave}
          initialValues={repeatConfig}
          repeatOption={repeatOption}
          adjustWeeknd={adjusWeekend}
          startDate={selectedDate}
        />
      )}
      {showDeleteModal && (
        <DeleteConfirmationModal
          visible={showDeleteModal}
          onConfirm={handleDelete.bind(null, email.id)}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}
    </div>
  );
};

export default ViewEmail;
